import { ObjectWrapper } from '../wrappers/object.wrapper';
import { DataObject } from '../models/domain/dataobject';
import { CommonEnums } from '../common.enums';
import { RepConn } from '../models/datapoint/repconn';
import { Design } from '../models/domain/design';
import { Stream } from '../models/domain/stream';
import { UDF } from '../models/domain/udf';
import { DBFun } from '../models/objects/dbfun';
import { DBSeq } from '../models/objects/dbseq';

export class ObjectUtil {
    private static instance: ObjectUtil;

    static getInstance() {
        if (!ObjectUtil.instance) {
            ObjectUtil.instance = new ObjectUtil();
        }

        return ObjectUtil.instance;
    }

    /**
    * ObjectUtil is a singleton class, so use ObjectUtil.getInstance() method instead of creating new ObjectUtil().
    */
    private constructor() {

    }

    getName(object: any): string {
        if (object instanceof DataObject) {
            return (object as DataObject).dObj.nm;
        }
        if (object instanceof RepConn) {
            return (object as RepConn).conn.nm;
        }
        if (object instanceof Design) {
            return (object as Design).dxMp.nm;
        }
        if (object instanceof Stream) {
            return (object as Stream).dxFlow.nm;
        }
        if (object instanceof UDF) {
            return (object as UDF).usr_Def_Fun.nm;
        }
        if (object instanceof DBFun) {
            return (object as DBFun).dxFun.nm;
        }
        if (object instanceof DBSeq) {
            return (object as DBSeq).native_Db_Seq.nm;
        }

    }

    getObjectName(object: any): string {
        if (object instanceof DataObject) {
            return CommonEnums.objectName.DATAOBJECT;
        }
        if (object instanceof RepConn) {
            return CommonEnums.objectName.REPCONN;
        }
        if (object instanceof Design) {
            if (object.dxMp.streamingFlg == CommonEnums.streamingFlg.DATACONNECT &&
                object.dxMp.reusableFlag == CommonEnums.reusableFlag.NO) {
                return CommonEnums.objectName.DATACONNECT;
            }
            if (object.dxMp.streamingFlg == CommonEnums.streamingFlg.YES &&
                object.dxMp.reusableFlag == CommonEnums.reusableFlag.NO) {
                return CommonEnums.objectName.DATASTREAM;
            }
            if (object.dxMp.streamingFlg == CommonEnums.streamingFlg.NO &&
                object.dxMp.reusableFlag == CommonEnums.reusableFlag.YES) {
                return CommonEnums.objectName.DATASUBFLOW;
            }
            return CommonEnums.objectName.DESIGN;
        }
        if (object instanceof Stream) {
            return CommonEnums.objectName.STREAM;
        }
        if (object instanceof UDF) {
            return CommonEnums.objectName.UDF;
        }
        if (object instanceof DBFun) {
            return CommonEnums.objectName.DBFUN;
        }
        if (object instanceof DBSeq) {
            return CommonEnums.objectName.DBSEQ;
        }
    }



    add(object: any, list: Array<any>, idField: string, nameField: string, objectWrapper: ObjectWrapper): any {

        return null;
    }

    delete(index: number): any {

        return null;
    }

    getUniqueName(value: string, names: Array<string>): string {
        let valueUC: string = value.toUpperCase();

        if (names.indexOf(valueUC) == -1) {
            return value;
        }

        let index: number = value.lastIndexOf('_');
        if (index != -1) {
            let postfix: string = value.substr(index + 1, value.length);
            if (Number.isNaN(parseInt(postfix))) {
                value = value.substr(0, index + 1);
            }
        } else {
            value += '_';
        }

        return value + this._getUniqueName(value.toUpperCase() + '_', names, 1);
    }

    private _getUniqueName(valueUC_: string, names: Array<string>, postfix: number): number {
        if (names.indexOf(valueUC_ + postfix) == -1) {
            return postfix;
        }

        return this._getUniqueName(valueUC_, names, ++postfix);
    }

    resetSrt_Order(list: Array<any>, index: number = 0): void {
        let length: number = list.length;
        for (let i: number = index; i < length; i++) {
            list[i].srt_Order = i;
        }
    }
}